import { configureStore } from "@reduxjs/toolkit";

import authReducer from "./auth";
import bankReducer from "./bank";
import blogReducer from "./blog";
import contactUsReducer from "./contact";
import depositReducer from "./deposit";
import gameReducer from "./game";
import languageReducer from "./language";
import messageReducer from "./member";
import promotionReducer from "./promotion";
import retrieveReducer from "./retrieve";
import userReducer from "./user";

const rootReducers = {
  auth: authReducer,
  game: gameReducer,
  bank: bankReducer,
  deposit: depositReducer,
  user: userReducer,
  retrieve: retrieveReducer,
  language: languageReducer,
  contactUs: contactUsReducer,
  member: messageReducer,
  promotion: promotionReducer,
  blog: blogReducer,
};

const store = configureStore({
  reducer: rootReducers,
});

export default store;
